// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Vehicles() {
//   const [vehicles, setVehicles] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [recordsPerPage, setRecordsPerPage] = useState(5);
//   const [deleteId, setDeleteId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // Fetch vehicles from backend
//   const fetchVehicles = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch("http://localhost:5000/api/vehicles");
//       if (!response.ok) throw new Error("Failed to fetch vehicles");
//       const data = await response.json();
//       setVehicles(data);
//       setFilteredData(data);
//     } catch (error) {
//       console.error("Error fetching vehicles:", error);
//       toast.error("Failed to load vehicles.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchVehicles();
//   }, []);

//   // Search filter
//   useEffect(() => {
//     const lower = searchQuery.toLowerCase();
//     if (!searchQuery.trim()) {
//       setFilteredData(vehicles);
//     } else {
//       setFilteredData(
//         vehicles.filter((v) =>
//           [v.ModelYear, v.Self ? "Yes" : "No", v.OwnerName, v.VehicleNo, v.VehicleTypeName]
//             .some((val) => val?.toString().toLowerCase().includes(lower))
//         )
//       );
//       setCurrentPage(1);
//     }
//   }, [searchQuery, vehicles]);

//   // Delete vehicle
//   const handleDelete = async () => {
//     if (!deleteId) return;
//     try {
//       setLoading(true);
//       const response = await fetch(
//         `http://localhost:5000/api/vehicles/${deleteId}`,
//         { method: "DELETE" }
//       );
//       if (!response.ok) throw new Error("Failed to delete vehicle");

//       toast.success("Vehicle deleted successfully!");
//       setVehicles((prev) => prev.filter((v) => v.ID !== deleteId));
//       setFilteredData((prev) => prev.filter((v) => v.ID !== deleteId));
//       setDeleteId(null);
//     } catch (error) {
//       console.error("Delete error:", error);
//       toast.error("Failed to delete vehicle.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const confirmDelete = (id) => setDeleteId(id);

//   // Pagination
//   const totalPages = Math.ceil(filteredData.length / recordsPerPage);
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = filteredData.slice(
//     indexOfFirstRecord,
//     indexOfLastRecord
//   );

//   return (
//     <>
//       <div className="Payment_div">
//         <div className="payment_maintext">
//           <h6>Vehicles</h6>
//           <div>
//             <Link className="payment_breadcrumbs" to={"/Vehicles"}>
//               <p>Vehicles</p>
//             </Link>
//             <span>
//               <i className="fa-solid fa-chevron-right"></i> Master
//             </span>
//           </div>
//         </div>

//         <div className="button_search-payment">
//           <Link to="/AddVehicles">
//             <button type="button" className="btn btn">
//               <i className="fa-solid fa-plus"></i> Add Vehicles
//             </button>
//           </Link>
//           <div className="search-input_box">
//             <input
//               type="search"
//               className="form-control"
//               placeholder="Search for vehicle..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>

//         {/* Records Per Page Dropdown */}
//         <div className="search-container mt-3">
//           <div className="records-per-page-container">
//             <label htmlFor="recordsPerPage">Records Per Page:</label>
//             <select
//               id="recordsPerPage"
//               value={recordsPerPage}
//               onChange={(e) => {
//                 setRecordsPerPage(Number(e.target.value));
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="5">5</option>
//               <option value="10">10</option>
//               <option value="15">15</option>
//               <option value="20">20</option>
//             </select>
//           </div>
//         </div>

//         <div className="vehicle-type-container mb-5">
//           <ToastContainer position="top-right" autoClose={3000} />

//           {loading ? (
//             <p>Loading vehicles...</p>
//           ) : currentRecords.length > 0 ? (
//             <div className="response-container w-2/4">
//               <div className="table-wrapper">
//                 <table className="data-table">
//                   <thead>
//                     <tr>
//                       <th>Model Year</th>
//                       <th>Self</th>
//                       <th>Owner Name</th>
//                       <th>Vehicle No</th>
//                       <th>Vehicle Type</th>
//                       <th className="w-14">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentRecords.map((v) => (
//                       <tr key={v.ID}>
//                         <td>{v.ModelYear}</td>
//                         <td>{v.Self ? "Yes" : "No"}</td>
//                         <td>{v.OwnerName}</td>
//                         <td>{v.VehicleNo}</td>
//                         <td>{v.VehicleTypeName}</td>
//                         <td>
//                           <div className="seletdata_edit-delet-btn">
//                             <Link
//                               to="/UpdateVehicles"
//                               state={{ vehicleData: v }}
//                             >
//                               <button
//                                 className="selet_edit-btn"
//                                 title="Edit"
//                               >
//                                 <i className="fa-solid fa-pen-to-square"></i>
//                               </button>
//                             </Link>
//                             <button
//                               className="select_delete-btn"
//                               data-bs-toggle="modal"
//                               data-bs-target="#deleteVehicleModal"
//                               onClick={() => confirmDelete(v.ID)}
//                             >
//                               <i className="fa-solid fa-trash"></i>
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Pagination */}
//               <div className="select_pagination mt-4">
//                 <button
//                   onClick={() =>
//                     setCurrentPage((prev) => Math.max(prev - 1, 1))
//                   }
//                   disabled={currentPage === 1}
//                 >
//                   Previous
//                 </button>
//                 <span>
//                   &nbsp; {currentPage} of {totalPages}
//                 </span>
//                 <button
//                   onClick={() =>
//                     setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                   }
//                   disabled={currentPage === totalPages}
//                 >
//                   &nbsp; Next
//                 </button>
//               </div>
//             </div>
//           ) : (
//             <p>No vehicles found.</p>
//           )}

//           {/* Delete Confirmation Modal */}
//           <div
//             className="modal fade"
//             id="deleteVehicleModal"
//             tabIndex="-1"
//             role="dialog"
//             aria-modal="true"
//             aria-labelledby="deleteModalTitle"
//           >
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content">
//                 <div className="close_topbutton-taxes">
//                   <button
//                     type="button"
//                     className="btn-close"
//                     data-bs-dismiss="modal"
//                   ></button>
//                 </div>
//                 <div className="delet_icon-boxtaxes">
//                   <i className="fa-solid fa-trash"></i>
//                 </div>
//                 <div className="taxes_pcolom">
//                   <h6 id="deleteModalTitle">Confirm Delete</h6>
//                   <p>Are you sure you want to delete?</p>
//                 </div>
//                 <div className="close_bottombutton-taxes">
//                   <button
//                     type="button"
//                     className="btn btn-secondary"
//                     data-bs-dismiss="modal"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="delete_button"
//                     data-bs-dismiss="modal"
//                     onClick={handleDelete}
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Vehicles;




// its old code dont delete it 

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Vehicles() {
//   const [vehicles, setVehicles] = useState([]);
//   const [vehicleTypes, setVehicleTypes] = useState([]);
//   const [owners, setOwners] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [recordsPerPage, setRecordsPerPage] = useState(5);
//   const [deleteId, setDeleteId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // ============================
//   // Fetch Vehicles
//   // ============================
//   const fetchVehicles = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch("http://localhost:5000/api/vehicles");
//       if (!response.ok) throw new Error("Failed to fetch vehicles");

//       const data = await response.json();
//       const vehiclesArray = Array.isArray(data.vehicles) ? data.vehicles : [];

//       // ✅ Sort vehicles alphabetically by VehicleNo
//       const sortedVehicles = [...vehiclesArray].sort((a, b) =>
//         (a.VehicleNo || "").localeCompare(b.VehicleNo || "", undefined, {
//           sensitivity: "base",
//         })
//       );

//       setVehicles(sortedVehicles);
//       setFilteredData(sortedVehicles);

//       // Build dropdown data
//       const types = sortedVehicles
//         .map((v) => ({ ID: v.VehicleTypeID, VTYPE: v.VehicleTypeName }))
//         .filter((v) => v.ID != null);

//       const ownersList = sortedVehicles
//         .map((v) => ({ HEAD_CODE: v.OwnerID, HEADName: v.OwnerName }))
//         .filter((o) => o.HEAD_CODE != null);

//       setVehicleTypes(types);
//       setOwners(ownersList);
//     } catch (error) {
//       console.error("Error fetching vehicles:", error);
//       toast.error("Failed to load vehicles.");
//       setVehicles([]);
//       setFilteredData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchVehicles();
//   }, []);

//   // ============================
//   // Search Filter
//   // ============================
//   useEffect(() => {
//     const lower = searchQuery.toLowerCase();
//     if (!searchQuery.trim()) {
//       setFilteredData(vehicles);
//     } else {
//       const searchFiltered = vehicles.filter((v) =>
//         [v.VehicleNo, v.VehicleTypeName, v.OwnerName, v.ModelYear].some((val) =>
//           val?.toString().toLowerCase().includes(lower)
//         )
//       );

//       // ✅ Sort search results alphabetically by VehicleNo
//       const sortedSearchResults = [...searchFiltered].sort((a, b) =>
//         (a.VehicleNo || "").localeCompare(b.VehicleNo || "", undefined, {
//           sensitivity: "base",
//         })
//       );

//       setFilteredData(sortedSearchResults);
//       setCurrentPage(1);
//     }
//   }, [searchQuery, vehicles]);

//   // ============================
//   // Delete Vehicle
//   // ============================
//   const confirmDelete = (id) => setDeleteId(id);

//   const handleDelete = async () => {
//     if (!deleteId) return;
//     try {
//       setLoading(true);
//       const response = await fetch(`http://localhost:5000/api/vehicles/${deleteId}`, {
//         method: "DELETE",
//       });
//       if (!response.ok) throw new Error("Failed to delete vehicle");

//       toast.success("Vehicle deleted successfully!");
//       const updatedVehicles = vehicles.filter((v) => v.ID !== deleteId);

//       // ✅ Sort updated list after deletion
//       const sortedUpdatedVehicles = [...updatedVehicles].sort((a, b) =>
//         (a.VehicleNo || "").localeCompare(b.VehicleNo || "", undefined, {
//           sensitivity: "base",
//         })
//       );

//       setVehicles(sortedUpdatedVehicles);
//       setFilteredData(sortedUpdatedVehicles);
//       setDeleteId(null);
//     } catch (error) {
//       console.error("Delete error:", error);
//       toast.error("Failed to delete vehicle.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ============================
//   // Pagination Logic
//   // ============================
//   const totalPages = Math.ceil((filteredData?.length || 0) / recordsPerPage);
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = (filteredData || []).slice(
//     indexOfFirstRecord,
//     indexOfLastRecord
//   );

//   return (
//     <>
//       <div className="Payment_div">
//         {/* Header */}
//         <div className="payment_maintext">
//           <h6>Vehicles</h6>
//           <div>
//             <Link className="payment_breadcrumbs" to={"/Vehicles"}>
//               <p>Vehicles</p>
//             </Link>
//             <span>
//               <i className="fa-solid fa-chevron-right"></i> Master
//             </span>
//           </div>
//         </div>

//         {/* Add Vehicle & Search */}
//         <div className="button_search-payment">
//           <Link to="/AddVehicles">
//             <button type="button" className="btn btn">
//               <i className="fa-solid fa-plus"></i> Add Vehicles
//             </button>
//           </Link>
//           <div className="search-input_box">
//             <input
//               type="search"
//               className="form-control"
//               placeholder="Search for vehicle..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>

//         {/* Records Per Page */}
//         <div className="search-container mt-3">
//           <div className="records-per-page-container">
//             <label htmlFor="recordsPerPage">Records Per Page:</label>
//             <select
//               id="recordsPerPage"
//               value={recordsPerPage}
//               onChange={(e) => {
//                 setRecordsPerPage(Number(e.target.value));
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="5">5</option>
//               <option value="10">10</option>
//               <option value="15">15</option>
//               <option value="20">20</option>
//             </select>
//           </div>
//         </div>

//         {/* Vehicle Table */}
//         <div className="vehicle-type-container mb-5">
//           <ToastContainer position="top-right" autoClose={3000} />
//           {loading ? (
//             <p>Loading vehicles...</p>
//           ) : currentRecords.length > 0 ? (
//             <div className="response-container w-2/4">
//               <div className="table-wrapper">
//                 <table className="data-table">
//                   <thead>
//                     <tr>
//                       {/* Added auto-grow styles */}
//                       <th style={{ minWidth: "120px", whiteSpace: "nowrap" }}>Vehicle No</th>
//                       <th style={{ minWidth: "120px", whiteSpace: "nowrap" }}>Vehicle Type</th>
//                       <th>Owner Name</th>
//                       <th>Model Year</th>
//                       <th className="w-14">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentRecords.map((v) => (
//                       <tr key={v.ID}>
//                         <td style={{ minWidth: "120px", whiteSpace: "nowrap" }}>
//                           {v.VehicleNo}
//                         </td>
//                         <td style={{ minWidth: "120px", whiteSpace: "nowrap" }}>
//                           {v.VehicleTypeName || "N/A"}
//                         </td>
//                         <td>
//                           {v.OwnerName ||
//                             owners.find((o) => o.HEAD_CODE === v.OwnerID)?.HEADName ||
//                             "N/A"}
//                         </td>
//                         <td>{v.ModelYear}</td>
//                         <td>
//                           <div className="seletdata_edit-delet-btn">
//                             <Link to="/UpdateVehicles" state={{ vehicleData: v }}>
//                               <button className="selet_edit-btn" title="Edit">
//                                 <i className="fa-solid fa-pen-to-square"></i>
//                               </button>
//                             </Link>
//                             <button
//                               className="select_delete-btn"
//                               data-bs-toggle="modal"
//                               data-bs-target="#deleteVehicleModal"
//                               onClick={() => confirmDelete(v.ID)}
//                             >
//                               <i className="fa-solid fa-trash"></i>
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Pagination */}
//               <div
//                 className="select_pagination mt-4"
//                 style={{
//                   textAlign: "center",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   gap: "10px",
//                 }}
//               >
//                 <button
//                   onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                   disabled={currentPage === 1}
//                   style={{ padding: "6px 12px", fontSize: "14px", cursor: "pointer" }}
//                 >
//                   Previous
//                 </button>
//                 <span style={{ fontSize: "12px" }}>
//                   Page {currentPage} of {totalPages}
//                 </span>
//                 <button
//                   onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
//                   disabled={currentPage === totalPages}
//                   style={{ padding: "6px 12px", fontSize: "12px", cursor: "pointer" }}
//                 >
//                   Next
//                 </button>
//               </div>
//             </div>
//           ) : (
//             <p>No vehicles found.</p>
//           )}
//         </div>

//         {/* Delete Modal */}
//         <div
//           className="modal fade"
//           id="deleteVehicleModal"
//           tabIndex="-1"
//           role="dialog"
//           aria-modal="true"
//           aria-labelledby="deleteModalTitle"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="close_topbutton-taxes">
//                 <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
//               </div>
//               <div className="delet_icon-boxtaxes">
//                 <i className="fa-solid fa-trash"></i>
//               </div>
//               <div className="taxes_pcolom">
//                 <h6 id="deleteModalTitle">Confirm Delete</h6>
//                 <p>Are you sure you want to delete?</p>
//               </div>
//               <div className="close_bottombutton-taxes">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   data-bs-dismiss="modal"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="delete_button"
//                   data-bs-dismiss="modal"
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Vehicles;






// add here the global key and data append

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { SECURITY_KEY } from "../../../globals";
import { apiWithLog } from "../../../utils/apiWithLog";
import DeleteConfirmModal from "../../../Component/DeleteModal/DeleteConfirmModal";
import { MasterTableSkeleton } from "../../../Component/Skeleton";
import "../Ledger/ShowLedger.css";

function Vehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [owners, setOwners] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [compID, setCompID] = useState(null);


  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;


  useEffect(() => {
    fetchVehicles();
  }, []);

  // ============================
  // Fetch Vehicles
  // ============================
  // const fetchVehicles = async () => {
  //   setError(null);
  //   setLoading(true);
  //   setVehicleTypes([]);

  //   const data = new URLSearchParams();
  //   // data.append("SecurityKey", "abcd");
  //   data.append("SecurityKey", SECURITY_KEY);
  //   data.append("TableName", "VehicleTypes");
  //   data.append("WhereCondition", "All");
  //   data.append("*", "*");
  //   try {
  //     setLoading(true);
  //     // const response = await fetch("http://localhost:5000/api/vehicles");
  //     // const response = await fetch("https://etour.responseinfoway.com/api/vehicles");
  //     const response = await fetch(`${BASE_API_URL}/vehicles`);
  //     if (!response.ok) throw new Error("Failed to fetch vehicles");

  //     const data = await response.json();
  //     const vehiclesArray = Array.isArray(data.vehicles) ? data.vehicles : [];

  //     // ✅ Sort vehicles alphabetically by VehicleNo
  //     const sortedVehicles = [...vehiclesArray].sort((a, b) =>
  //       (a.VehicleNo || "").localeCompare(b.VehicleNo || "", undefined, {
  //         sensitivity: "base",
  //       })
  //     );

  //     setVehicles(sortedVehicles);
  //     setFilteredData(sortedVehicles);

  //     // Build dropdown data
  //     const types = sortedVehicles
  //       .map((v) => ({ ID: v.VehicleTypeID, VTYPE: v.VehicleTypeName }))
  //       .filter((v) => v.ID != null);

  //     const ownersList = sortedVehicles
  //       .map((v) => ({ HEAD_CODE: v.OwnerID, HEADName: v.OwnerName }))
  //       .filter((o) => o.HEAD_CODE != null);

  //     setVehicleTypes(types);
  //     setOwners(ownersList);
  //   } catch (error) {
  //     console.error("Error fetching vehicles:", error);
  //     toast.error("Failed to load vehicles.");
  //     setVehicles([]);
  //     setFilteredData([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

    /* =====================================================
     🔹 WATCH COMPANY CHANGE (NO REFRESH, SAME TAB)
  ====================================================== */
  useEffect(() => {
    const loadCompany = () => {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));
      if (company?.id && !isNaN(company.id)) {
        setCompID(Number(company.id));
      }
    };

    // initial load
    loadCompany();

    // watch for change
    const interval = setInterval(() => {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));
      if (
        company?.id &&
        !isNaN(company.id) &&
        Number(company.id) !== compID
      ) {
        setCompID(Number(company.id));
      }
    }, 500);

    return () => clearInterval(interval);
  }, [compID]);

  /* =====================================================
     🔹 FETCH VEHICLES (SAFE FUNCTION)
  ====================================================== */
  const fetchVehicles = async (companyID) => {
    // 🛑 HARD GUARD
    if (!companyID || isNaN(companyID)) {
      console.warn("❌ fetchVehicles skipped, invalid CompID:", companyID);
      return;
    }

    setError(null);
    setLoading(true);
    setVehicleTypes([]);
    setOwners([]);

    try {
      const response = await fetch(
        `${BASE_API_URL}/vehicles/${companyID}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch vehicles");
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error("Backend returned error");
      }

      const vehiclesArray = Array.isArray(data.vehicles)
        ? data.vehicles
        : [];

      // ✅ Sort alphabetically
      const sortedVehicles = [...vehiclesArray].sort((a, b) =>
        (a.VehicleNo || "").localeCompare(b.VehicleNo || "", undefined, {
          sensitivity: "base",
        })
      );

      setVehicles(sortedVehicles);
      setFilteredData(sortedVehicles);

      // 🔹 Build Vehicle Types dropdown (unique)
      const types = [
        ...new Map(
          sortedVehicles
            .filter(v => v.VehicleTypeID)
            .map(v => [
              v.VehicleTypeID,
              { ID: v.VehicleTypeID, VTYPE: v.VehicleTypeName }
            ])
        ).values()
      ];

      // 🔹 Build Owners dropdown (unique)
      const ownersList = [
        ...new Map(
          sortedVehicles
            .filter(v => v.OwnerID)
            .map(v => [
              v.OwnerID,
              { HEAD_CODE: v.OwnerID, HEADName: v.OwnerName }
            ])
        ).values()
      ];

      setVehicleTypes(types);
      setOwners(ownersList);

    } catch (err) {
      console.error("❌ Error fetching vehicles:", err);
      showToast.error("Failed to load vehicles.");
      setVehicles([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  /* =====================================================
     🔹 AUTO FETCH WHEN CompID CHANGES
  ====================================================== */
  useEffect(() => {
    if (!compID || isNaN(compID)) {
      console.warn("❌ Skipping API call, CompID invalid:", compID);
      return;
    }

    fetchVehicles(compID);
  }, [compID]);

  useEffect(() => {
    fetchVehicles();
  }, []);

  // ============================
  // Search Filter
  // ============================
  useEffect(() => {
    const lower = searchQuery.toLowerCase();
    if (!searchQuery.trim()) {
      setFilteredData(vehicles);
    } else {
      const searchFiltered = vehicles.filter((v) =>
        [
          v.VehicleNo,
          (v.Self === 1 || v.Self === true || v.Self === "1") ? "Self" : "Others",
          v.VehicleTypeName,
          v.OwnerName,
          v.ModelYear
        ].some((val) =>
          val?.toString().toLowerCase().includes(lower)
        )
      );

      // ✅ Sort search results alphabetically by VehicleNo
      const sortedSearchResults = [...searchFiltered].sort((a, b) =>
        (a.VehicleNo || "").localeCompare(b.VehicleNo || "", undefined, {
          sensitivity: "base",
        })
      );

      setFilteredData(sortedSearchResults);
      setCurrentPage(1);
    }
  }, [searchQuery, vehicles]);

  // ============================
  // Delete Vehicle
  // ============================
  const confirmDelete = (v) => {
    setDeleteId(v.ID);
    setDeleteItemName(v.VehicleNo || `Vehicle #${v.ID}`);
    setDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    if (isDeleting) return;
    if (!deleteId) return;

    try {
      setIsDeleting(true);

      // ============================
      // API with Logging (Node)
      // ============================
      const res = await apiWithLog({
        method: "DELETE",
        url: `${BASE_API_URL}/vehicles/${deleteId}`,
        module: "VehicleMaster",
        action: "D",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = res.data;

      if ((res.status === 200 || res.status === 204) && (result?.status || result?.success || result?.message)) {
        showToast.delete("Vehicle deleted successfully!");

        const updatedVehicles = vehicles.filter((v) => v.ID !== deleteId);

        // ✅ Sort updated list after deletion
        const sortedUpdatedVehicles = [...updatedVehicles].sort((a, b) =>
          (a.VehicleNo || "").localeCompare(b.VehicleNo || "", undefined, {
            sensitivity: "base",
          })
        );

        setVehicles(sortedUpdatedVehicles);
        setFilteredData(sortedUpdatedVehicles);
        setDeleteModalOpen(false);
        setDeleteId(null);
      } else {
        showToast.error(result?.message || "Failed to delete vehicle.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      showToast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to delete vehicle."
      );
    } finally {
      setIsDeleting(false);
    }
  };

  // ============================
  // Pagination Logic
  // ============================
  const totalPages = Math.ceil((filteredData?.length || 0) / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = (filteredData || []).slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  return (
    <div className="ledger_page_container">
      {/* TOP HEADER & BREADCRUMBS */}
      <div className="ledger_header_bar">
        <div className="ledger_header_title_group">
          <h4 className="ledger_header_title">Vehicle Master</h4>
          <div className="ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <span>Master</span>
            <span>/</span>
            <span>Vehicles</span>
          </div>
        </div>
      </div>

      {/* TOP CONTROLS CARD */}
      <div className="ledger_top_controls">
        <div className="ledger_top_left">
          <Link to="/AddVehicles" className="new_ledger_btn">
            + Add Vehicle
          </Link>
        </div>

        <div className="ledger_top_right">
          <div className="ledger_search_box">
            <input
              type="search"
              className="ledger_search_input"
              placeholder="Search vehicles..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="ledger_records_select_group">
            <label htmlFor="recordsPerPage">Show:</label>
            <select
              id="recordsPerPage"
              className="ledger_records_select"
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
      </div>

      {/* TABLE CARD */}
      <div className="ledger_table_section">
        {loading && (
          <MasterTableSkeleton columns={6} rows={6} hasToolbar={false} />
        )}

        {error && !loading && (
          <div className="ledger_empty_state">
            <h6>Error Loading Data</h6>
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && currentRecords.length > 0 && (
          <>
            <div className="ledger_table_wrapper">
              <table className="ledger_table">
                <thead>
                  <tr>
                    <th>Vehicle No</th>
                    <th>Ownership</th>
                    <th>Vehicle Type</th>
                    <th>Owner Name</th>
                    <th>Model Year</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRecords.map((v) => (
                    <tr key={v.ID}>
                      <td className="ledger_name_cell">{v.VehicleNo}</td>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "3px 8px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            fontWeight: "600",
                            backgroundColor: (v.Self === 1 || v.Self === true || v.Self === "1") ? "#dcfce7" : "#f1f5f9",
                            color: (v.Self === 1 || v.Self === true || v.Self === "1") ? "#166534" : "#475569",
                          }}
                        >
                          {v.Self === 1 || v.Self === true || v.Self === "1" ? "Self" : "Others"}
                        </span>
                      </td>
                      <td>
                        {v.VehicleTypeName ||
                          vehicleTypes.find(
                            (vt) => String(vt.ID) === String(v.VehicleTypeID)
                          )?.VTYPE ||
                          vehicleTypes.find(
                            (vt) => String(vt.ID) === String(v.VehicleTypeID)
                          )?.Name ||
                          "N/A"}
                      </td>
                      <td>
                        {v.OwnerName ||
                          owners.find(
                            (o) => String(o.HEAD_CODE) === String(v.OwnerID)
                          )?.HEADName ||
                          owners.find(
                            (o) => String(o.HEAD_CODE) === String(v.OwnerID)
                          )?.LedgerName ||
                          "N/A"}
                      </td>
                      <td>{v.ModelYear}</td>
                      <td className="ledger_actions_cell">
                        <div className="ledger_actions_wrapper">
                          <Link
                            to="/UpdateVehicles"
                            state={{ vehicleData: v }}
                          >
                            <button
                              type="button"
                              className="ledger_btn_edit"
                              title="Edit Vehicle"
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </button>
                          </Link>
                          <button
                            type="button"
                            className="ledger_btn_delete"
                            title="Delete Vehicle"
                            onClick={() => confirmDelete(v)}
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* PAGINATION SECTION */}
            <div className="ledger_pagination_container">
              <div className="ledger_pagination_info">
                Showing {indexOfFirstRecord + 1} to{" "}
                {Math.min(indexOfLastRecord, (filteredData || []).length)} of{" "}
                {(filteredData || []).length} records
              </div>

              <div className="ledger_pagination_controls">
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="ledger_page_badge">
                  Page {currentPage} of {totalPages || 1}
                </span>
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() =>
                    setCurrentPage((p) => Math.min(p + 1, totalPages))
                  }
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}

        {!loading && !error && currentRecords.length === 0 && (
          <div className="ledger_empty_state">
            <h6>No Vehicles Found</h6>
            <p>
              {searchQuery
                ? `No vehicles matching "${searchQuery}"`
                : "No vehicles available."}
            </p>
          </div>
        )}
      </div>

      {/* Reusable Custom Delete Confirmation Modal */}
      <DeleteConfirmModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDelete}
        title="Delete Vehicle?"
        message="Are you sure you want to delete this vehicle record?"
        itemName={deleteItemName}
        loading={isDeleting}
      />
    </div>
  );
}

export default Vehicles;